module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "id": "ded",
      "title": "Dedication"
    }
  }, [_c('h1', {
    staticClass: "ded_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062878823_Contents#rded"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticClass: "top3"
  }, [_c('p', {
    staticClass: "ded_pb"
  }, [_c('i', [_vm._v("To everyone who has struggled with mental health issues")]), _vm._v("—"), _c('i', [_vm._v("and to those who have helped them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded_pe"
  }, [_c('i', [_vm._v("In memory of Letty and Henry, whose lives inspire me, and Madelyn, whose daughter inspires me.")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63dc7c6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062878823_Dedication.vue
// module id = 60
// module chunks = 0